import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResettableService {
  public resetNow: Subject<boolean> = new Subject();

  constructor() {}
}
